module.exports = __webpack_public_path__ + "static/media/login-background1-tw-as.0af05695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-background1-tw-as.png
// module id = 1095
// module chunks = 110